import { createAsyncReducer } from '@telstra-connect/standard-actions/reducers';
import {
    IFileUploadAction,
    IFileUploadSuccessAction,
    IFileUploadErrorAction,
    IFileUploadResetAction,
    IFileUploadRemoveFileAction
} from '../actions/file-upload';
import { IStoreIntState } from '../state';
import { initialState } from '../state/initial-state';
import { getFilteredFilesList,getRemovedFilesList } from './update-cart';

export type FileUploadAction
    = IFileUploadAction
    | IFileUploadSuccessAction
    | IFileUploadErrorAction
    | IFileUploadRemoveFileAction

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const init = (state: IStoreIntState, action: FileUploadAction) => ({
    ...state,
    fileUploads: {
        ...state.fileUploads,
        status: action.status,
    }
});

const success = (state: IStoreIntState, action: FileUploadAction) => {
    const fileUploadState = {...state.fileUploads.data}
    if(fileUploadState[(action as IFileUploadSuccessAction).data.popId]){
        fileUploadState[(action as IFileUploadSuccessAction).data.popId].push((action as IFileUploadSuccessAction).data.data)
    } else {
        fileUploadState[(action as IFileUploadSuccessAction).data.popId] = [(action as IFileUploadSuccessAction).data.data]
    }
    return {
    ...state,
    fileUploads: {
        ...state.fileUploads,
        data: {...fileUploadState},
        status: action.status,
    }
};
};

const failure = (state: IStoreIntState, action: FileUploadAction) => ({
    ...state,
    fileUploads: {
        ...initialState.fileUploads,
        status: action.status,
        error: (action as IFileUploadErrorAction).error
    }
});

const reset = (state: IStoreIntState, action: FileUploadAction) => ({
    ...state,
    fileUploads: {
        status: action.status,
        data: getFilteredFilesList(state.fileUploads.data,(action as IFileUploadResetAction).data) 
    }
});

const remove = (state: IStoreIntState, action: FileUploadAction) => ({
    ...state,
    fileUploads: {
        status: action.status,
        data: getRemovedFilesList(state.fileUploads.data,(action as IFileUploadRemoveFileAction).data) 
    }
});

export const fileUploadReducer = createAsyncReducer(initialState, init, success, failure,reset, remove);
